<template>
  <div ref="grid" :class="className">
    <slot />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { useContainerBreakpointClasses } from "#/shared/composables/useContainerBreakpointClasses";

const props = defineProps({
  widthBreakpoints: {
    type: String,
    default: undefined,
  },
  heightBreakpoints: {
    type: String,
    default: undefined,
  },
});

const grid = useTemplateRef("grid");
const className = "tile-grid";

useContainerBreakpointClasses(grid, {
  widthBreakpoints: () => props.widthBreakpoints,
  heightBreakpoints: () => props.heightBreakpoints,
});
</script>

<style lang="scss" scoped>
.tile-grid {
  display: grid;
  grid-template-columns: repeat(var(--sp-comp-dtv-tile-grid-columns, auto-fit), minmax(20ch, 1fr));
  gap: var(--sp-comp-dtv-tile-grid-gap, 0.75rem);
}
</style>
